module.exports = __webpack_public_path__ + "static/media/feature.b308a0ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/MensHealthWA/feature.jpg
// module id = 243
// module chunks = 0